import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/site/Layout";
import { Reveal } from "@/components/site/Reveal";
import { Eyebrow } from "@/components/site/Eyebrow";

export const Route = createFileRoute("/thank-you")({
  head: () => ({
    meta: [
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { title: "Thank You | Avolus Cars Vancouver" },
      {
        name: "description",
        content:
          "Your message has been received by the Avolus Cars concierge. We reply during operating hours, 8AM-8PM, 7 days a week.",
      },
      { property: "og:title", content: "Thank You | Avolus Cars" },
      { property: "og:description", content: "Your enquiry has reached the Avolus concierge." },
      { property: "og:url", content: "https://avoluscars.com/thank-you" },
      { name: "robots", content: "noindex, follow" },
    ],
    links: [{ rel: "canonical", href: "https://avoluscars.com/thank-you" }],
  }),
  component: ThankYou,
});

function ThankYou() {
  return (
    <Layout>
      <section className="pt-40 pb-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <Reveal>
            <Eyebrow>Message received</Eyebrow>
            <h1 className="font-display text-5xl md:text-7xl text-foreground">
              Thank you. We'll be in touch.
            </h1>
            <p className="mt-6 text-foreground/70 max-w-2xl">
              Your enquiry has reached the Avolus concierge. We reply during operating hours:
              8:00 AM - 8:00 PM, 7 days a week. If your
              request is urgent, call us directly at{" "}
              <a href="tel:+17783798881" className="text-foreground underline underline-offset-4">
                +1-778-379-8881
              </a>
              .
            </p>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="mt-12 flex flex-wrap gap-4">
              <a
                href="/fleet"
                className="inline-flex items-center justify-center text-xs uppercase tracking-[0.25em] px-8 py-4 bg-foreground text-background hover:bg-foreground/90 transition-colors"
              >
                Browse the fleet
              </a>
              <a
                href="/book"
                className="inline-flex items-center justify-center text-xs uppercase tracking-[0.25em] px-8 py-4 border border-border text-foreground hover:bg-accent transition-colors"
              >
                Book a vehicle
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.25}>
            <div className="mt-16 border-t border-border pt-10 grid gap-6 sm:grid-cols-3 text-sm text-muted-foreground">
              <p>
                <a href="/rates" className="text-foreground underline underline-offset-4">
                  Rates and mileage
                </a>
                : daily pricing, multi-day discounts and what's included.
              </p>
              <p>
                <a href="/delivery" className="text-foreground underline underline-offset-4">
                  Delivery
                </a>
                : we bring the car to you across Metro Vancouver, YVR and Whistler.
              </p>
              <p>
                <a href="/faq" className="text-foreground underline underline-offset-4">
                  FAQ
                </a>
                : requirements, deposits, insurance and cancellation.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </Layout>
  );
}
